import { useEffect, useState } from "react";
import { getMergedArticles } from "@/lib/articles-db";
import { type Article, type ArticleCategory, articlesByCategory as staticByCat } from "@/data/articles";

export function useArticles(category?: ArticleCategory) {
  const [articles, setArticles] = useState<Article[]>(() =>
    category ? staticByCat(category) : [],
  );

  useEffect(() => {
    let cancel = false;
    getMergedArticles(category).then((arts) => {
      if (!cancel) setArticles(arts);
    });
    return () => { cancel = true; };
  }, [category]);

  return articles;
}
